<template>
  <div>
    <div v-show="showChart"><canvas id="cmchart"></canvas></div>
    <div v-show="!showChart" class="mt-10">Tidak ada data tersedia</div>
  </div>
</template>
<script>
import { Chart } from 'chart.js'
import zoomPlugin from 'chartjs-plugin-zoom'
Chart.register(zoomPlugin)

export default {
  props: {
    chartData: {},
  },
  data() {
    return {
      chartView: '',
      showChart: false,
    }
  },
  mounted() {
    const ctx = document.getElementById('cmchart').getContext('2d')

    this.chartView = new Chart(ctx, {
      type: 'line',
      options: {
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true,
              },
              mode: 'xy',
            },
          },
        },
      },
    })
  },
  watch: {
    chartData: {
      handler(newVal, oldVal) {
        if (newVal.titik_ukur.length > 0) {
          this.showChart = true
        } else {
          this.showChart = false
        }
        this.chartView.data.labels = []
        var listMin = []
        var listMax = []
        var listAverage = []

        //reset data
        this.chartView.data.datasets = []
        // this.chartView.data.datasets.forEach(dataset => {
        //   dataset.data = []
        // })

        newVal.titik_ukur.forEach((row) => {
          var average = 0
          var total = 0
          row.titik_ukur.forEach((n) => {
            total = total + parseFloat(n.nilai_titik_ukur)
          })
          average = total / row.titik_ukur.length
          listMin.push(newVal.data.batas_min)
          listMax.push(newVal.data.batas_max)
          listAverage.push(average)

          this.chartView.data.labels.push(row.tanggal)
        })

        var dataSetMin = {
          label: 'Min',
          data: listMin,
          borderColor: '#F64E60',
          backgroundColor: '#F64E60',
        }

        var dataSetMax = {
          label: 'Max',
          data: listMax,
          borderColor: '#181c32',
          backgroundColor: '#181c32',
        }

        var dataSetAverage = {
          label: 'Average',
          data: listAverage,
          borderColor: '#fcc43f',
          backgroundColor: '#fcc43f',
        }
        this.chartView.data.datasets.push(dataSetMin)
        this.chartView.data.datasets.push(dataSetMax)
        this.chartView.data.datasets.push(dataSetAverage)
        //this.chartView.options.scales.y.max = 10
        this.chartView.update()
      },
      deep: true,
    },
  },
}
</script>
